import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { JoinGame } from 'src/app/models/game.interface';
import {
  AuthService,
  HttpService,
  NotifyService,
  NotificationSeverity,
  TokenService,
} from 'src/app/services';
import { environment as env } from 'src/environments/environment';

@Component({
  selector: 'cm-loading-page',
  templateUrl: './loading-page.component.html',
  styleUrls: ['./loading-page.component.css']
})
export class LoadingPageComponent implements OnInit {
  protected providerCode: string;
  protected gameCode: string;
  protected language: string | null;
  protected isProviderDisable: boolean;
  protected isTestGame: boolean;

  constructor(
    private route: ActivatedRoute,
    private auth: AuthService,
    private http: HttpService,
    private notification: NotifyService,
    private token: TokenService,
    private translate: TranslateService,
  ) {
    this.providerCode = '';
    this.gameCode = '';
    this.language = '';
    this.isProviderDisable = false;
    this.isTestGame = false;
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.providerCode = params['providerCode'];
      this.gameCode = params['gameCode'];
      this.isTestGame = params['isTestGame'] === 'true';
    });

    this.language = this.token.getLocalToken(env.TokenKeys.LanguageToken);
    if(this.isTestGame){
      this.joinTestGame(this.providerCode, this.gameCode);
    }
    else{
      this.joinGame(this.providerCode, this.gameCode);
    }
  }

  protected joinTestGame(providerCode: string, gameCode: string, isFree = 1) {
    
    const payload: any = {
      ProviderId: providerCode,
      Language: this.language,
      Mobile: false
    };

    this.http.post('game', 'trialgameurl', payload).subscribe((resp: JoinGame) => {
      if (resp && resp.Code == 1) {
        window.location.href = resp.Url[0];
      } 
      else if (resp && resp.Code == 108) {
        this.isProviderDisable = true;
      }
      else {
        var title = '',
          message = '';

        this.translate
          .get('notifications.contact_support.title')
          .subscribe((text: string) => {
            title = text;
          });

        this.translate
          .get('notifications.contact_support.message')
          .subscribe((text: string) => {
            message = text;
          });

        this.notification.displayNotification(
          title,
          message,
          NotificationSeverity.Error
        );

        // Wait 3 seconds before closing the window
        // setTimeout(() => {
          window.close();
        // }, 3000);
      }
    });
  }

  protected joinGame(providerCode: string, gameCode: string, isFree = 1) {
    if (!this.auth.isAuthenticated()) {
      this.auth.toggleLoginDisplay(!this.auth.isAuthenticated());
      return;
    }

    const payload: any = {
      CurrentCulture: this.language,
      UserRoleId: 0,
      LoggedInAcctUserId: null,
      UserAgent: null,
      Country: null,
      ProviderId: providerCode,
      MerchantId: '',
      SessionId: '',
      GameCode: gameCode,
      RealMoney: true,
      Language: this.language,
      Mobile: false,
      GameType: '',
      GameName: ''
    };

    this.http.post('game', 'gameurl', payload).subscribe((resp: JoinGame) => {
      if (resp && resp.Code == 1) {
        window.location.href = resp.Url[0];
      } 
      else if (resp && resp.Code == 108) {
        this.isProviderDisable = true;
      }
      else {
        var title = '',
          message = '';

        this.translate
          .get('notifications.contact_support.title')
          .subscribe((text: string) => {
            title = text;
          });

        this.translate
          .get('notifications.contact_support.message')
          .subscribe((text: string) => {
            message = text;
          });

        this.notification.displayNotification(
          title,
          message,
          NotificationSeverity.Error
        );

        // Wait 3 seconds before closing the window
        // setTimeout(() => {
          window.close();
        // }, 3000);
      }
    });
  }
}
